import React from 'react';
import Styled from 'styled-components';
import { Flex } from '@ui-library/misc';
import moment from 'moment';
import Button from '@ui-library/button';
import { SettingOutlined } from '@ant-design/icons';
import SyncSchedulePopup from '@components/sources/source-view/source-settings/components/sync-schedule-popup';
import Tooltip from '@ui-library/tooltip';
import useModalView from '@hooks/useModalView';
import theme from '@css/theme';

export interface NextScheduleProps {
  nextSchedule?: string;
  isAdmin: boolean;
}

const Container = Styled(Flex)`
  font-size: 14px;
  color: ${theme.color.neutral2};
  margin-left: 1.5rem;
  & > div{color:${({ theme }) => theme.color.neutral3};}
`;
const NextSchedule = ({ nextSchedule, isAdmin }: NextScheduleProps) => {
  const [syncModal, showSyncModal] = useModalView(
    <SyncSchedulePopup onCancel={() => showSyncModal(false)} />,
  );
  return (
    <Container alignItems="center">
      {syncModal}
      <div>
        Next sync: {/* Sync should be manual if nextSchedule is an empty string. */}
        {nextSchedule ? moment(nextSchedule).format('dddd MMMM DD, hh:mmA Z') : 'Not scheduled'}
        &nbsp;
      </div>
      {isAdmin && (
        <Tooltip title="Manage sync schedule">
          <Button
            type="text"
            icon={<SettingOutlined />}
            onClick={() => showSyncModal(true)}
            data-testid="update_sync_schedule"
          />
        </Tooltip>
      )}
    </Container>
  );
};

export default NextSchedule;
